<p-table #purchase [value]="purchaseHistory" responsiveLayout="scroll" [paginator]="true" [rows]="pageSize"
    [showCurrentPageReport]="true" [rowsPerPageOptions]="rowsPerPage"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" (onPage)="onPageChange($event)"
    [totalRecords]="totalRecordPurchase" [lazy]="true">
    <ng-template pTemplate="caption">
        <div class="p-text-right">
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input type="text" pInputText placeholder="Search" (input)="searchFilter()"
                    [(ngModel)]="searchValuePurchase" />
            </span>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th>Bill/RPO Date</th>
            <th>Bill/RPO No.</th>
            <th>PO Date</th>
            <th>PO No.</th>
            <th>Cost</th>
            <th>PO Qty</th>
            <th>Received Qty</th>
            <th *ngIf="module == 'product'">Vendor</th>
            <th>Location</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
        <tr>
            <td>{{product.billDate | date:'MM/dd/YYYY'}}</td>
            <td style="cursor: pointer; color: #517fa4;" (click)="onRouteNavigation(product,'Bill')">
                {{product.billId}}
            </td>
            <td>{{product.poDate ? (product.poDate | date:'MM/dd/YYYY') : 'N/A'}}</td>
            <td [class.pointer]="product.poId" style="cursor: pointer; color: #517fa4;"
                (click)="onRouteNavigation(product,'PO')">{{product.poId ? product.poId : 'N/A'}}</td>
            <td>{{product.productCost ? (product.productCost | customNumberFormat: length | currencySymbol) : 'N/A'}}</td>
            <td>{{product.poQty | customNumberFormat: qtyDecimal }}</td>
            <td>{{product.receivedQty | customNumberFormat: qtyDecimal }}</td>
            <td *ngIf="module == 'product'" style="cursor: pointer; color: #517fa4;"
                (click)="onRouteNavigation(product,'vendor')">{{product.vendorName}}</td>
            <td style="cursor: pointer; color: #517fa4;" (click)="onRouteNavigation(product,'location')">
                {{product.warehouseName}}</td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="9" class="p-text-center">
                {{noPurchaseFindOrLoadingText}}
            </td>
        </tr>
    </ng-template>
</p-table>


<app-inventory-module-overview-dialogs *ngIf="displayInventoryOverview" [displayOverview]="displayInventoryOverview"
    [overviewRefId]="inventoryOverviewRefId" [overviewRefNumber]="inventoryOverviewRefNumber" [trackingOptions]="trackingOptions"
    [overviewModule]="inventoryOverviewModule" (onCancel)="closeViewPopup()">
</app-inventory-module-overview-dialogs>


<!-- Tracking Information -->
<p-dialog header="Tracking Information" [(visible)]="displayScanInfo" [modal]="true" [responsive]="true"
    [closable]="false" [style]="{ width: '70vw' }" (onHide)="savedOptionSelection=null;">
    <div class="card">
        <div class="p-field p-formgrid p-grid">
            <p-table [value]="nameLists" class="w-100" [lazy]="true" [paginator]="true" [first]="first"
                [totalRecords]="totalTBRecord" [rows]="pageSize" [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [rowsPerPageOptions]="rowsPerPageTB" (onPage)="loadSerialsLazy($event)">
                <ng-template pTemplate="header">
                    <tr>
                        <th id="lot"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'lotChecked',savedOptionSelection)">
                            {{utilityService.displayName(trackingOptions,'lotChecked','label')}}
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'lotChecked','control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'lotChecked','control')=='Currency'">({{utilityService.displayName(trackingOptions,'lotChecked','currency')}})</span>
                        </th>
                        <th id="revision"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'revisionChecked',savedOptionSelection)">
                            {{utilityService.displayName(trackingOptions,'revisionChecked','label')}}
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'revisionChecked','control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'revisionChecked','control')=='Currency'">({{utilityService.displayName(trackingOptions,'revisionChecked','currency')}})</span>
                        </th>
                        <th id="expiration"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'expirationChecked',savedOptionSelection)">
                            {{utilityService.displayName(trackingOptions,'expirationChecked','label')}}
                        </th>
                        <th id="serial"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serializedChecked',savedOptionSelection)">
                            {{utilityService.displayName(trackingOptions,'serializedChecked','label')}}</th>
                        <th id="serial2"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial2Checked',savedOptionSelection)">
                            {{utilityService.displayName(trackingOptions,'serial2Checked','label')}}
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial2Checked','control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial2Checked','control')=='Currency'">({{utilityService.displayName(trackingOptions,'serial2Checked','currency')}})</span>
                        </th>
                        <th id="serial3"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial3Checked',savedOptionSelection)">
                            {{utilityService.displayName(trackingOptions,'serial3Checked','label')}}
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial3Checked','control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial3Checked','control')=='Currency'">({{utilityService.displayName(trackingOptions,'serial3Checked','currency')}})</span>
                        </th>
                        <th id="serial4"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial4Checked',savedOptionSelection)">
                            {{utilityService.displayName(trackingOptions,'serial4Checked','label')}}
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial4Checked','control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial4Checked','control')=='Currency'">({{utilityService.displayName(trackingOptions,'serial4Checked','currency')}})</span>
                        </th>
                        <th id="serial5"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial5Checked',savedOptionSelection)">
                            {{utilityService.displayName(trackingOptions,'serial5Checked','label')}}
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial5Checked','control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial5Checked','control')=='Currency'">({{utilityService.displayName(trackingOptions,'serial5Checked','currency')}})</span>
                        </th>
                        <th id="serial6"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial6Checked',savedOptionSelection)">
                            {{utilityService.displayName(trackingOptions,'serial6Checked','label')}}
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial6Checked','control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial6Checked','control')=='Currency'">({{utilityService.displayName(trackingOptions,'serial6Checked','currency')}})</span>
                        </th>
                        <th id="serial7"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial7Checked',savedOptionSelection)">
                            {{utilityService.displayName(trackingOptions,'serial7Checked','label')}}
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial7Checked','control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial7Checked','control')=='Currency'">({{utilityService.displayName(trackingOptions,'serial7Checked','currency')}})</span>
                        </th>
                        <th id="serial8"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial8Checked',savedOptionSelection)">
                            {{utilityService.displayName(trackingOptions,'serial8Checked','label')}}
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial8Checked','control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial8Checked','control')=='Currency'">({{utilityService.displayName(trackingOptions,'serial8Checked','currency')}})</span>
                        </th>
                        <th id="serial9"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial9Checked',savedOptionSelection)">
                            {{utilityService.displayName(trackingOptions,'serial9Checked','label')}}
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial9Checked','control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial9Checked','control')=='Currency'">({{utilityService.displayName(trackingOptions,'serial9Checked','currency')}})</span>
                        </th>
                        <th id="serial10"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial10Checked',savedOptionSelection)">
                            {{utilityService.displayName(trackingOptions,'serial10Checked','label')}}
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial10Checked','control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial10Checked','control')=='Currency'">({{utilityService.displayName(trackingOptions,'serial10Checked','currency')}})</span>
                        </th>
                        <th id="serial11"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial11Checked',savedOptionSelection)">
                            {{utilityService.displayName(trackingOptions,'serial11Checked','label')}}
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial11Checked','control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial11Checked','control')=='Currency'">({{utilityService.displayName(trackingOptions,'serial11Checked','currency')}})</span>
                        </th>
                        <th id="serial12"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial12Checked',savedOptionSelection)">
                            {{utilityService.displayName(trackingOptions,'serial12Checked','label')}}
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial12Checked','control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial12Checked','control')=='Currency'">({{utilityService.displayName(trackingOptions,'serial12Checked','currency')}})</span>
                        </th>
                        <th id="serial13"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial13Checked',savedOptionSelection)">
                            {{utilityService.displayName(trackingOptions,'serial13Checked','label')}}
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial13Checked','control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial13Checked','control')=='Currency'">({{utilityService.displayName(trackingOptions,'serial13Checked','currency')}})</span>
                        </th>
                        <th id="serial14"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial14Checked',savedOptionSelection)">
                            {{utilityService.displayName(trackingOptions,'serial14Checked','label')}}
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial14Checked','control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial14Checked','control')=='Currency'">({{utilityService.displayName(trackingOptions,'serial14Checked','currency')}})</span>
                        </th>
                        <th id="serial15"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial15Checked',savedOptionSelection)">
                            {{utilityService.displayName(trackingOptions,'serial15Checked','label')}}
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial15Checked','control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial15Checked','control')=='Currency'">({{utilityService.displayName(trackingOptions,'serial15Checked','currency')}})</span>
                        </th>
                        <th id="serial16"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial16Checked',savedOptionSelection)">
                            {{utilityService.displayName(trackingOptions,'serial16Checked','label')}}
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial16Checked','control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial16Checked','control')=='Currency'">({{utilityService.displayName(trackingOptions,'serial16Checked','currency')}})</span>
                        </th>
                        <th id="serial17"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial17Checked',savedOptionSelection)">
                            {{utilityService.displayName(trackingOptions,'serial17Checked','label')}}
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial17Checked','control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName(trackingOptions,'serial17Checked','control')=='Currency'">({{utilityService.displayName(trackingOptions,'serial17Checked','currency')}})</span>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-i="rowIndex">
                    <tr>
                        <td
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'lotChecked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilityService.displayName(trackingOptions,'lotChecked','control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.lotNo }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.lotNo &&
                                    product.lotNo |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'revisionChecked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilityService.displayName(trackingOptions,'revisionChecked','control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.revisionNo }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.revisionNo &&
                                    product.revisionNo |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'expirationChecked',savedOptionSelection)">
                            {{product.expiration | date: 'MM/dd/yyyy'}}
                        </td>
                        <td
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serializedChecked',savedOptionSelection)">
                            {{
                            product.serialNo }}</td>
                        <td
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial2Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilityService.displayName(trackingOptions,'serial2Checked','control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo2 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo2 &&
                                    product.serialNo2 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial3Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilityService.displayName(trackingOptions,'serial3Checked','control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo3 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo3 &&
                                    product.serialNo3 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial4Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilityService.displayName(trackingOptions,'serial4Checked','control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo4 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo4 &&
                                    product.serialNo4 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial5Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilityService.displayName(trackingOptions,'serial5Checked','control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo5 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo5 &&
                                    product.serialNo5 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial6Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilityService.displayName(trackingOptions,'serial6Checked','control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo6 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo6 &&
                                    product.serialNo6 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial7Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilityService.displayName(trackingOptions,'serial7Checked','control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo7 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo7 &&
                                    product.serialNo7 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial8Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilityService.displayName(trackingOptions,'serial8Checked','control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo8 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo8 &&
                                    product.serialNo8 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial9Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilityService.displayName(trackingOptions,'serial9Checked','control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo9 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo9 &&
                                    product.serialNo9 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial10Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilityService.displayName(trackingOptions,'serial10Checked','control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo10 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo10 &&
                                    product.serialNo10 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial11Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilityService.displayName(trackingOptions,'serial11Checked','control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo11 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo11 &&
                                    product.serialNo11 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial12Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilityService.displayName(trackingOptions,'serial12Checked','control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo12 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo12 &&
                                    product.serialNo12 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial13Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilityService.displayName(trackingOptions,'serial13Checked','control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo13 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo13 &&
                                    product.serialNo13 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial14Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilityService.displayName(trackingOptions,'serial14Checked','control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo14 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo14 &&
                                    product.serialNo14 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial15Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilityService.displayName(trackingOptions,'serial15Checked','control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo15 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo15 &&
                                    product.serialNo15 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial16Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilityService.displayName(trackingOptions,'serial16Checked','control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo16 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo16 &&
                                    product.serialNo16 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial17Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilityService.displayName(trackingOptions,'serial17Checked','control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo17 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo17 &&
                                    product.serialNo17 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayScanInfo = false" label="Cancel"
            class="p-button-secondary"></button>
    </p-footer>
</p-dialog>